// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/components/chatinterface/components/chatcomposer/index.scss
// module id = 2531
// module chunks = 13